const Theme = {
  placeholdercol: '#00a9df',
  lg: '25px',
  md: '17px',
  sm: '14px',
  xs: '12px'
};

export default Theme;
